var _defs, _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333334 333334",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 162482,
    y1: 307276,
    x2: 170852,
    y2: 26057.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19a8dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#2ab2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cbde8"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166667,
    cy: 166667,
    r: 166667,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246886 91205l-29735 149919s-4158 10396-15594 5404l-68618-52606-24952-12059-42002-14140s-6446-2288-7069-7277c-624-4992 7277-7694 7277-7694l166970-65498s13722-6030 13722 3951z",
    fill: "#fefefe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127666 239440s-2003-188-4499-8089c-2495-7901-15178-49487-15178-49487l100846-64043s5822-3535 5614 0c0 0 1040 623-2079 3534s-79222 71320-79222 71320l-5481 46765z",
    fill: "#d4e6f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159250 214094l-27141 24745s-2122 1609-4443 601l5197-45965 26387 20619z",
    fill: "#b6d0e5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgTelegram);
export default __webpack_public_path__ + "static/media/svg_telegram.af763f87892a6afa388b2a6b2f7d4a8e.svg";
export { ForwardRef as ReactComponent };